<div class="loader" [ngClass]="{ 'loader--full-screen': fullScreen, hide: hide }">
  <div class="loader__view-box">
    <span class="loader__dot"></span>
    <span class="loader__dot"></span>
    <span class="loader__dot"></span>
  </div>
</div>